import _ from 'lodash';
import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import responseKeyNormalizerMapping from './mapping';
import { MicroApp } from './micro';
import ClinicalFunctionBarService from './service/ClinicalFunctionBarService';
import ClinicalOperationService from './service/ClinicalOperationService';
export default class ClinicalDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
        this.silencedUpdateQueryKeys = ['page', 'sort'];
        this.microapp = new MicroApp(this.microAppId);
    }
    get enabled() {
        return localStorage.getItem('workspaceDetail:clinical') !== 'false';
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return ClinicalOperationService;
    }
    get FunctionBarServiceClass() {
        return ClinicalFunctionBarService;
    }
    get isRefineEnabled() {
        return true;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 4,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailClinicalRoot' },
        };
    }
    getReloadIdentifier(route) {
        const params = this._queryParamsNormalizer(route);
        return JSON.stringify(_.omit(params, this.silencedUpdateQueryKeys));
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(route) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(route),
            };
        }
        return {
            path: this.name,
            name: 'detailClinicalRoot',
            component: () => import('./ClinicalDetail.vue'),
            props: getDetailPageProps,
        };
    }
    _preload() {
        this.microapp.preload();
        return Promise.resolve();
    }
}
